import { gsap } from 'gsap';

gsap.defaults({
  ease: 'power4.out',
  duration: 1,
});

const mainNavAnim = (state) => {
  const tl = gsap.timeline({ paused: true });
  tl.fromTo('.nav-main', { y: '100%', opacity: 1 }, { y: 0, opacity: 1 });
  tl.fromTo(
    '.nav-main li',
    { opacity: 0, y: 30 },
    { opacity: 1, y: 0, stagger: 0.1 },
    '-=0.5',
  );
  state === true ? tl.play() : tl.reverse(0);
};

export const navOpen = () => {
  const body = document.querySelector('body');
  const nav = document.querySelector('.nav-main');
  if (body.dataset.nav === 'inactive') {
    mainNavAnim(true);
    body.dataset.nav = 'active';
    nav.dataset.menu = 'active';
  } else {
    mainNavAnim(false);
    body.dataset.nav = 'inactive';
    nav.dataset.menu = 'inactive';
  }
};
